import { render } from "./License.vue?vue&type=template&id=68e63b04"
import script from "./License.vue?vue&type=script&lang=js"
export * from "./License.vue?vue&type=script&lang=js"

import "./License.vue?vue&type=style&index=0&id=68e63b04&lang=less"

import exportComponent from "/workspace/workdir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__